import { registerServiceWorker } from './service-worker.util';

declare global {
  interface Window {
    worker: ServiceWorker;
  }
}

navigator.serviceWorker.addEventListener('message', (event) => {
  const { data } = event;
  console.log('Message:', data);
});

registerServiceWorker('/sw/service-worker.js').then((serviceWorker) => {
  window.worker = serviceWorker;

  (navigator.serviceWorker.controller || serviceWorker).postMessage(
    'ServiceWorker has been installed successfully.',
  );
});
